import {defineComponent, PropType} from '@vue/composition-api';
import $ from 'jquery';

export enum SlideType {

    vertical,

    horizontal,

    both
}

export default defineComponent({

    props: {

        slideType: {

            required: false,

            type: Number as PropType<SlideType>,

            default: SlideType.vertical
        },

        duration: {

            required: false,

            type: Number,

            default: 350
        }
    },

    setup(props) {

        const properties = (animateType: string) => {

            const v = props.slideType === SlideType.vertical || props.slideType === SlideType.both;

            const h = props.slideType === SlideType.horizontal || props.slideType === SlideType.both;

            return {
                width: h ? animateType : undefined,
                height: v ? animateType : undefined
            }
        }

        const enter = (element: HTMLElement) =>  $(element).hide().animate(properties('show'), props.duration);

        const leave = (element: HTMLElement) =>  $(element).animate(properties('hide'), props.duration, () => $(element).css({width: 0, height: 0, display: 'none', overflow: 'hidden'}));

        return {

            enter,

            leave
        }
    }
});
